import { render, staticRenderFns } from "./journalAdModal.vue?vue&type=template&id=2fb6f8d8&"
import script from "./journalAdModal.vue?vue&type=script&lang=js&"
export * from "./journalAdModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports